import { render, staticRenderFns } from "./SmallMenuItem.vue?vue&type=template&id=70e7ba1b&scoped=true"
import script from "./SmallMenuItem.vue?vue&type=script&lang=js"
export * from "./SmallMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SmallMenuItem.vue?vue&type=style&index=0&id=70e7ba1b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7ba1b",
  null
  
)

export default component.exports